import React, { PureComponent, ReactNode } from 'react';
import { loadConfig } from '../../services/Config';

interface Props {
  children: ReactNode;
  loading?: ReactNode;
  onLoad?(): void;
  url?: string;
}

interface State {
  loading: boolean;
  loaded: boolean;
}

export class ConfigProvider extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      loaded: false,
      loading: false,
    };
  }

  componentDidMount() {
    // En mode production, on charge un fichier de configuration
    // Sinon on passe par les variables d'environnements et on n'a pas besoin
    // de charger de fichier de configuration
    if (process.env.NODE_ENV === 'production') {
      const { url } = this.props;
      fetch(url || '/config.json')
        .then(response => {
          return response.json();
        })
        .then((content: string) => {
          loadConfig(content);
          this.setState({
            loaded: true,
          });
          this.props.onLoad && this.props.onLoad();
        });
    } else {
      this.setState({
        loaded: true,
      });
      this.props.onLoad && this.props.onLoad();
    }
  }

  render() {
    if (this.state.loading) {
      return this.props.loading;
    }
    if (this.state.loaded) {
      return <>{this.props.children}</>;
    }
    return null;
  }
}
